import { CloseCircleOutlined } from "@ant-design/icons";
import { Tag } from "antd";
import { Tooltip } from "antd";
import React from "react";
import { $t } from "~/i18n.js";

export const PilotLink = ({ name, id, object, betalend_lid_id }) => {
  if (!name) return "-";
  const isLinked = object?.id;
  return isLinked ? (
    <a
      onClick={(e) => e.stopPropagation()}
      target="_blank"
      href={`/members/${object.id}`}
    >
      {name} ({id})

      {betalend_lid_id && id === betalend_lid_id && <Tag color="blue" style={{marginLeft: 6}}>{$t('Betalend lid')}</Tag>}
    </a>
  ) : (
    <Tooltip placement="top" title={$t("Piloot niet gekoppeld")}>
      <CloseCircleOutlined color="grey" /> {name} ({id || "-"})
    </Tooltip>
  );
};
